import { DataCollectorInstance, TransactionCollector } from '@scfe-common/core';
import { handleResponseData } from '../../utils';
import { ActionType, RequestState } from '@scfe-common/chain-tracker';
import { CustomActionType } from '@/utils/chain-tracker/plugins/types';

export default [
  {
    name: 'SLASaleInboundCartonCounting',
    status: {
      errorCount: 0,
    },
    scanTime: 'custom_CartonCounting_scan_time',
    scanErrorCount: 'custom_CartonCounting_scan_time_error_count',
    scanTaskTime: 'custom_CartonCounting_scan_taskID_time',
    scanTaskErrorCount: 'custom_CartonCounting_scan_taskID_time_error_count',
    collector: {} as TransactionCollector,
    getPointList: function () {
      return [
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#carton-counting-input-taskID',
          },
          handler: () => {
            this.collector = DataCollectorInstance.createTransactionCollector();
            this.collector.startTrack({
              name: this.scanTaskTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/parcelcounting\/join_parcel_counting_task(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanTaskTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanTaskErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
          },
        },
        {
          type: CustomActionType.Focus,
          rule: {
            selectors: '#carton-counting-input-id',
          },
          handler: () => {
            this.collector.startTrack({
              name: this.scanTime,
            });
          },
        },
        {
          type: ActionType.REQUEST,
          rule: {
            url: /^\/api\/v2\/apps\/process\/inbound\/parcelcounting\/scan_and_save_parcel(\?.*)?$/,
            state: RequestState.After,
          },
          handler: (trackData: any, sendDataFn: any) => {
            const response = handleResponseData(trackData);

            const [result] = this.collector.endTrackByName({
              name: this.scanTime,
              isSuccess: true,
            });

            sendDataFn({
              pointId: result.name,
              customData: { ...result, type: 'experienceTime' },
            });
            sendDataFn({
              pointId: this.scanErrorCount,
              customData: {
                errorCount_n: Number(response?.retcode !== 0),
                type: 'experienceCount',
              },
            });
            DataCollectorInstance.removeTransactionCollector({
              traceId: this.collector.traceId,
            });
          },
        },
      ];
    },
  },
];
